import {utilHelper} from "../../_helpers";

const relativeUrl = '/api/categoryPromotion'

export const categoryPromotionService = {
    search,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    syncFirebase
};


function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data, showAlert: false })
}

function syncFirebase() {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncFirebase`, 'GET', { })
}

function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET', { })
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', {data});
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', {data});
}

function deleteItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE', { })
}